import {useEffect, useRef, useState} from 'react';

/**
 * @param {number} count
 * @returns {{focusState: boolean}}
 */
export default function usePrepareUnreadMessage({count}) {
  const pageTitle = useRef(document.title);
  const blinkIntervalRef = useRef(null);
  const [focusState, setFocusState] = useState(true);

  useEffect(() => {
    const handleFocusEvent = () => setFocusState(true);
    const handleBlurEvent = () => setFocusState(false);
    window.addEventListener('focus', handleFocusEvent);
    window.addEventListener('blur', handleBlurEvent);

    return () => {
      window.removeEventListener('focus', handleFocusEvent);
      window.removeEventListener('blur', handleBlurEvent);
    };
  }, []);

  useEffect(() => {
    if (focusState) {
      blinkIntervalRef.current && clearInterval(blinkIntervalRef.current);
      blinkIntervalRef.current = null;
      document.title = count ? `(${count}) ${pageTitle.current}` : pageTitle.current;
      return;
    }

    if (!count) return;
    blinkIntervalRef.current && clearInterval(blinkIntervalRef.current);
    blinkIntervalRef.current = setInterval(() => {
      if (document.title !== `(${count}) ${pageTitle.current}`) {
        document.title = `(${count}) ${pageTitle.current}`;
      } else {
        document.title = `(${count}) You have a new message`;
      }
    }, 3000);
  }, [focusState, count]);

  return {focusState};
}
